import toast from 'react-hot-toast';

export const AUTH_KEYS = [
  'ms_access_token',
  'ms_refresh_token',
  'ms_token_expires_at',
  'google_access_token',
  'active_provider',
  'ms_user_email',
  'ms_user_role',
  'ms_user_name',
];

export function clearAuthSession() {
  AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function handleSessionExpired(reason = 'Your mail session has expired. Please sign in again.') {
  clearAuthSession();
  toast.error(reason, { duration: 5000 });
  // Redirect to login/home and reload to clear any in-memory state
  if (window.location.pathname !== '/') {
    window.location.href = '/';
  } else {
    window.location.reload();
  }
}

export function isTokenExpiredError(error) {
  if (!error) return false;
  const status = error.response?.status;
  const data = error.response?.data || {};
  return (
    status === 401 ||
    data.code === 'TOKEN_EXPIRED' ||
    data.requiresReauth === true ||
    (data.error || '').toLowerCase().includes('expired') ||
    (data.error || '').toLowerCase().includes('invalid_token') ||
    (error.message || '').toLowerCase().includes('expired')
  );
}
